export const useSocialLoginLinks = () => {
	const config = useNuxtApp().$config
	const route = useRoute()

	const originPath = computed(() => {
		const query = { ...route.query }
		delete query.code
		delete query.error
		const queryString = new URLSearchParams(query as Record<string, string>).toString()
		return route.path + (queryString ? `?${queryString}` : '')
	})

	const googleLoginPath = computed(() => config.public.apiBaseURL + '/auth/google/redirect?origin-path=' + originPath.value)
	const appleLoginPath = computed(() => config.public.apiBaseURL + '/auth/apple/redirect?origin-path=' + originPath.value)

	return { googleLoginPath, appleLoginPath }
}

export const useOAuthCodeLogin = () => {
	const route = useRoute()
	const router = useRouter()
	const userStore = useUserStore()

	const loginByCode = async (hooks?: { onSuccess?: () => unknown; onSettled?: () => unknown }) => {
		const code = route.query.code as string
		if (!code) return
		try {
			await userStore.loginByToken(code)
			await hooks?.onSuccess?.()
		} catch (error) {
			logger.log(error)
		} finally {
			router.push({ query: {} })
			await hooks?.onSettled?.()
		}
	}

	return { loginByCode }
}
